
import "../styles/tryitout.css"









const hd2 = {   
 
    fontFamily: 'Poppins',
    columnGap:'10px',
   color:'white', textAlign:'left', 
   marginBottom:'10%',
   justifyContent:'center',
   alignItems:'center'}


export const disclaimerMssg = `By ticking this checkbox, I grant JoyFuel by Laroye AI my explicit consent to analyze the social media data I have uploaded. I understand that this analysis is intended to offer personalized insights and recommendations to improve my social media usage habits and overall mental wellness.

I acknowledge that JoyFuel by Laroye AI is committed to maintaining the highest standards of privacy and data security. Accordingly, I have been informed that: 

Data Analysis: My data will solely be used for the purpose of conducting the analysis to offer personalized insights by JoyFuel. 
Data Deletion: JoyFuel by Laroye AI guarantees that all of my files will be deleted promptly upon the completion of the analysis. 
No Third-Party Sharing: JoyFuel by Laroye AI will not share my information with any third parties for business or other purposes outside the scope of the intended analysis.\n
I understand that these measures are undertaken to ensure my privacy is safeguarded at all times, and that JoyFuel by Laroye AI is devoted to upholding the trust I place in their services.`


export const steps = (<p className="tio" style={hd2}>
Step 1 <br/>
Go to your Account settings by clicking on the &quot;more&quot; icon (three horizontal dots) in the navigation
bar, and selecting Your account from the menu.
<br/><br/>Step 2<br/>
Click on Download an archive of your data.
<br/><br/>Step 3<br/>
Enter your password under Download an archive of your data, then click Confirm.
<br/><br/>Step 4<br/>
Verify your identity by clicking Send code to your email address and/or phone number on file. If you
do not have an email address or phone number on file, you will be redirected to the Account
information page.
<br/><br/>Step 5<br/>
Enter the code sent to your email address and/or phone number.
<br/><br/>Step 6<br/>
After verifying your identity, click the Request data button. If your X account is connected to
Periscope, you’ll have the option to request an archive of your Periscope data on Periscope directly.
<br/><br/>Step 7<br/>
When your download is ready, we&#39;ll send an email to your connected email account or a push
notification if you have the app installed. From your settings, you can click the Download data button
under the Download data section.
<br/><br/>Step 8<br/>
Once you receive the email, click the Download button while logged in to your X account and
download a .zip file of your X archive.
<br/><br/>Note: Please make sure your email address is confirmed prior to requesting your X archive and that
you are logged into your X account on the same browser you are using to download your X archive.
Instructions and troubleshooting tips for confirming your email address may be found here. It may
take a few days for us to prepare the download of your X archive.
  </p>);
